export default class CalculateMyBonusCTA {
  constructor (options) {
    this.element = options.element
    this.calculatorSection = document.querySelector('#calculate-my-bonus')
    this.scrollOptions = {
      speed: 1000,
      easing: 'easeOutQuart',
      updateURL: true,
      after: () => {
        this.calculatorSection.classList.add('active')
      }
    }

    this.element.addEventListener('click', e => {
      document.body.classList.remove('locked')
      window.smoothScroll.animateScroll(
        this.calculatorSection,
        this.element,
        this.scrollOptions
      )
    })
  }
}



// WEBPACK FOOTER //
// ./components/calculate-my-bonus-cta/index.js